import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

export default function AdminSidebarNavItem({
  item,
  sidebarCollapsed = false,
  addonPendingCount = 0,
  auditNewCount = 0,
  onClick,
  mobile = false,
}) {
  const { path, icon: Icon, label, exact, auditBadge, addonBadge } = item;
  const badgeCount = addonBadge ? addonPendingCount : auditBadge ? auditNewCount : 0;
  const classes = mobile
    ? ({ isActive }) => cn(
        'flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors',
        isActive ? 'bg-slate-200 dark:bg-slate-700 text-slate-900 dark:text-white' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-slate-200',
      )
    : ({ isActive }) => cn(
        'flex items-center gap-3 rounded-md text-sm font-medium transition-all duration-200',
        sidebarCollapsed ? 'justify-center px-2 py-2.5' : 'px-3 py-2.5',
        isActive ? 'bg-slate-200 dark:bg-slate-700 text-slate-900 dark:text-white border-l-2 border-slate-500 dark:border-slate-400' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-slate-200',
      );
  const content = (
    <NavLink to={path} end={exact} onClick={onClick} data-testid={`admin-nav-${label.toLowerCase().replace(/\s/g, '-')}`} className={classes}>
      <Icon size={20} weight="bold" />
      {(!sidebarCollapsed || mobile) && (
        <span className="flex-1 flex items-center justify-between gap-2">
          {label}
          {badgeCount > 0 && (
            <span className={cn('min-w-[1.25rem] h-5 px-1 rounded-full text-white text-[10px] font-bold flex items-center justify-center', addonBadge ? 'bg-amber-500' : 'bg-red-500')}>
              {badgeCount > 9 ? '9+' : badgeCount}
            </span>
          )}
        </span>
      )}
    </NavLink>
  );
  if (sidebarCollapsed && !mobile) {
    return (
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>{content}</TooltipTrigger>
        <TooltipContent side="right">{label}</TooltipContent>
      </Tooltip>
    );
  }
  return content;
}
